module.exports = __webpack_public_path__ + "media/images/beauty/cover-mobile-9f4e54c239a746935099b15f7348f34b.jpg";